import { render } from "./ActivityIntro.vue?vue&type=template&id=5d4870c6&scoped=true"
import script from "./ActivityIntro.vue?vue&type=script&lang=js"
export * from "./ActivityIntro.vue?vue&type=script&lang=js"

import "./ActivityIntro.vue?vue&type=style&index=0&id=5d4870c6&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\Anael\\Documents\\developpement\\teachup-video-interactive\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d4870c6"]])

export default __exports__